var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsulationOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5308 58.8513H59.6978V58.8427C60.527 58.7586 61.1674 58.0557 61.1674 57.2059V3.65572C61.1674 2.75405 60.4325 2.0191 59.5308 2.0191H22.453C21.5513 2.0191 20.8163 2.75402 20.8163 3.65572V57.2147C20.8163 58.1163 21.5513 58.8513 22.453 58.8513H59.5308ZM57.8941 5.29234V55.578H24.0896V5.29234H57.8941Z",
    fill: "url(#paint0_linear_34666_9950)",
    stroke: "url(#paint1_linear_34666_9950)",
    strokeWidth: 0.334113
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1961 58.8513H32.3632V58.8426C33.1875 58.7581 33.8327 58.0558 33.8327 57.2059V3.65572C33.8327 2.75405 33.0978 2.0191 32.1961 2.0191C31.2945 2.0191 30.5595 2.75402 30.5595 3.65572V57.2147C30.5595 58.1163 31.2944 58.8513 32.1961 58.8513Z",
    fill: "url(#paint2_linear_34666_9950)",
    stroke: "url(#paint3_linear_34666_9950)",
    strokeWidth: 0.334113
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5653 58.8513H50.7323V58.8426C51.5566 58.7581 52.2019 58.0558 52.2019 57.2059V3.65572C52.2019 2.75405 51.467 2.0191 50.5653 2.0191C49.6636 2.0191 48.9286 2.75402 48.9286 3.65572V57.2147C48.9286 58.1163 49.6636 58.8513 50.5653 58.8513Z",
    fill: "url(#paint4_linear_34666_9950)",
    stroke: "url(#paint5_linear_34666_9950)",
    strokeWidth: 0.334113
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7727 12.0602H37.453C36.6435 12.0602 35.9834 11.4 35.9834 10.5906C35.9834 9.78119 36.6436 9.12103 37.453 9.12103H41.7727C42.5821 9.12103 43.2422 9.78119 43.2422 10.5906C43.2422 11.4 42.5878 12.0602 41.7727 12.0602Z",
    fill: "url(#paint6_linear_34666_9950)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7727 25.0165H37.453C36.6435 25.0165 35.9834 24.3564 35.9834 23.547C35.9834 22.7375 36.6436 22.0774 37.453 22.0774H41.7727C42.5821 22.0774 43.2422 22.7375 43.2422 23.547C43.2422 24.3535 42.5878 25.0165 41.7727 25.0165Z",
    fill: "url(#paint7_linear_34666_9950)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7727 37.97H37.453C36.6435 37.97 35.9834 37.3099 35.9834 36.5004C35.9834 35.691 36.6436 35.0309 37.453 35.0309H41.7727C42.5821 35.0309 43.2422 35.691 43.2422 36.5004C43.2422 37.3099 42.5878 37.97 41.7727 37.97Z",
    fill: "url(#paint8_linear_34666_9950)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7727 50.9235H37.453C36.6435 50.9235 35.9834 50.2633 35.9834 49.4539C35.9834 48.6445 36.6436 47.9844 37.453 47.9844H41.7727C42.5821 47.9844 43.2422 48.6445 43.2422 49.4539C43.2422 50.2633 42.5878 50.9235 41.7727 50.9235Z",
    fill: "url(#paint9_linear_34666_9950)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0861 18.5409H40.7664C39.957 18.5409 39.2969 17.8808 39.2969 17.0714C39.2969 16.2619 39.957 15.6018 40.7664 15.6018H45.0861C45.8956 15.6018 46.5557 16.262 46.5557 17.0714C46.5557 17.8808 45.8927 18.5409 45.0861 18.5409Z",
    fill: "url(#paint10_linear_34666_9950)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0861 31.4974H40.7664C39.957 31.4974 39.2969 30.8372 39.2969 30.0278C39.2969 29.2184 39.957 28.5582 40.7664 28.5582H45.0861C45.8956 28.5582 46.5557 29.2184 46.5557 30.0278C46.5557 30.8344 45.8927 31.4974 45.0861 31.4974Z",
    fill: "url(#paint11_linear_34666_9950)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0861 44.4419H40.7664C39.957 44.4419 39.2969 43.7818 39.2969 42.9724C39.2969 42.1629 39.957 41.5028 40.7664 41.5028H45.0861C45.8956 41.5028 46.5557 42.163 46.5557 42.9724C46.5557 43.7818 45.8927 44.4419 45.0861 44.4419Z",
    fill: "url(#paint12_linear_34666_9950)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6646 43.4554H2.46966C2.02888 43.4554 1.5878 43.2766 1.26788 42.9312L2.6646 43.4554ZM2.6646 43.4554L2.6629 43.4445M2.6646 43.4554L2.6629 43.4445M2.6629 43.4445C2.9942 43.4071 3.31737 43.273 3.58684 43.0382L3.5869 43.0383L3.5908 43.0347C4.20018 42.4686 4.49472 42.1953 4.7219 42.0248C4.9403 41.8608 5.09269 41.7944 5.43199 41.6477L5.43248 41.6475C5.91717 41.4362 6.60733 41.2376 7.21081 41.3973C7.50891 41.4792 7.82603 41.6424 8.20587 41.9217L8.20584 41.9218L8.20931 41.9242C8.30166 41.9885 8.3966 42.0584 8.48847 42.1308L8.48906 42.1312L8.49869 42.1387C8.73088 42.32 8.99906 42.5293 9.30567 42.7162L9.30616 42.7165C10.5384 43.4618 12.0612 43.6561 13.4925 43.2628L13.4929 43.2627C14.749 42.914 15.9023 42.1441 16.8259 41.0329L16.8259 41.0328C17.4046 40.3359 17.3082 39.3066 16.6121 38.7255L16.6118 38.7253C15.9149 38.1466 14.8856 38.243 14.3045 38.939L14.3043 38.9393C13.8138 39.5296 13.2102 39.9403 12.6181 40.1047C12.0394 40.2579 11.4505 40.1854 11.0009 39.911L11.0009 39.9109L10.9972 39.9088C10.8483 39.8231 10.7132 39.7167 10.5692 39.6035C10.5426 39.5826 10.5158 39.5614 10.4884 39.5401L10.4884 39.5401L10.4865 39.5386C10.4284 39.4947 10.3724 39.4514 10.3156 39.4076L10.3155 39.4075C10.2589 39.3638 10.2016 39.3196 10.142 39.2745L10.1409 39.2737C9.4348 38.7492 8.7473 38.4088 8.04108 38.2189L8.04108 38.2189L8.03988 38.2186C6.82089 37.9005 5.45925 38.0454 4.11638 38.6318C3.54694 38.8798 3.21299 39.0436 2.84022 39.3164C2.47839 39.5813 2.08143 39.948 1.38722 40.5894L1.35742 40.6169L1.35717 40.6171C0.695761 41.2306 0.653784 42.269 1.26784 42.9312L2.6629 43.4445Z",
    fill: "url(#paint13_linear_34666_9950)",
    stroke: "url(#paint14_linear_34666_9950)",
    strokeWidth: 0.334113
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46966 32.5512L2.46966 32.5512C2.02888 32.5512 1.5878 32.3724 1.26788 32.027L2.46966 32.5512ZM2.46966 32.5512C2.86898 32.5512 3.26445 32.4045 3.58233 32.1465L3.58256 32.1467L3.59073 32.1392C4.20011 31.5731 4.49465 31.2998 4.72183 31.1293C4.94023 30.9653 5.09262 30.8988 5.43192 30.7522L5.43192 30.7522L5.4334 30.7516C5.90844 30.5408 6.59865 30.3421 7.20215 30.5018M2.46966 32.5512L12.6088 29.2094M8.57459 31.104C8.56132 31.0936 8.54817 31.0832 8.5351 31.0728C8.45484 31.0094 8.37763 30.9484 8.29617 30.8916C7.90582 30.6046 7.57 30.4295 7.24566 30.3405M8.57459 31.104L3.47703 32.0168C4.68826 30.8916 4.68826 30.8916 5.36564 30.5989C5.85075 30.3836 6.5855 30.1655 7.24566 30.3405M8.57459 31.104C8.80997 31.2877 9.08265 31.4944 9.38402 31.6781L8.57459 31.104ZM7.24566 30.3405L7.20146 30.5016C7.20169 30.5017 7.20192 30.5018 7.20215 30.5018M7.24566 30.3405L7.20283 30.502C7.2026 30.502 7.20238 30.5019 7.20215 30.5018M7.20215 30.5018C7.50025 30.5837 7.81736 30.7469 8.19721 31.0262L8.19718 31.0263L8.20065 31.0287C8.27766 31.0823 8.3505 31.1399 8.431 31.2035C8.44418 31.2139 8.45756 31.2245 8.4712 31.2352L8.47181 31.2357C8.70814 31.4201 8.98707 31.6318 9.29708 31.8207L9.29757 31.821C10.5298 32.5663 12.0526 32.7606 13.4839 32.3673L13.4843 32.3672C14.7404 32.0185 15.8937 31.2486 16.8173 30.1374L16.8173 30.1373C17.396 29.4404 17.2996 28.4111 16.6035 27.83L16.6032 27.8297C15.9063 27.2511 14.877 27.3475 14.2959 28.0435L14.2957 28.0438C13.805 28.6343 13.2012 29.0451 12.6088 29.2094M12.6088 29.2094C12.0323 29.3676 11.4486 29.2909 10.9915 29.015L10.9905 29.0144C10.8344 28.9217 10.6841 28.8043 10.5287 28.6827C10.5125 28.6701 10.4962 28.6573 10.4798 28.6446L10.4798 28.6446L10.4779 28.6431C10.4198 28.5992 10.3638 28.5559 10.307 28.5121L10.3068 28.5119C10.2503 28.4683 10.193 28.424 10.1334 28.379L10.1323 28.3781C9.4275 27.8547 8.73952 27.5047 8.03106 27.323M12.6088 29.2094L1.26784 32.027C0.653784 31.3649 0.695761 30.3264 1.35717 29.713L1.35742 29.7127C2.07026 29.0542 2.47344 28.6821 2.84067 28.4152C3.21351 28.1441 3.54755 27.9825 4.11653 27.7362C5.45901 27.1501 6.82053 27.0049 8.03106 27.323M12.6088 29.2094C12.6087 29.2094 12.6086 29.2095 12.6086 29.2095L12.6532 29.3705M12.6088 29.2094C12.6089 29.2094 12.6089 29.2094 12.609 29.2094L12.6532 29.3705M8.03106 27.323C8.0309 27.323 8.03074 27.323 8.03058 27.3229L7.9891 27.4847M8.03106 27.323C8.03123 27.3231 8.0314 27.3231 8.03157 27.3232L7.9891 27.4847M7.9891 27.4847C8.67222 27.6598 9.34095 27.9985 10.0327 28.5123M7.9891 27.4847C6.82087 27.1776 5.49775 27.3154 4.18315 27.8894L10.0327 28.5123M10.0327 28.5123C10.0916 28.5568 10.1483 28.6006 10.2051 28.6444C10.2617 28.6882 10.3183 28.7319 10.3771 28.7763C10.3935 28.7891 10.41 28.802 10.4265 28.815L10.0327 28.5123ZM12.6532 29.3705C13.2846 29.1954 13.9161 28.762 14.4242 28.1506L12.6532 29.3705Z",
    fill: "url(#paint15_linear_34666_9950)",
    stroke: "url(#paint16_linear_34666_9950)",
    strokeWidth: 0.334113
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67621 21.9947H2.46966C2.02888 21.9947 1.5878 21.8159 1.26788 21.4705L2.67621 21.9947ZM2.67621 21.9947L2.67349 21.9819M2.67621 21.9947L2.67349 21.9819M2.67349 21.9819C3.00246 21.941 3.32081 21.8021 3.59142 21.5809L3.59164 21.5812L3.5994 21.574C4.20878 21.0079 4.50332 20.7346 4.7305 20.5641C4.9489 20.4001 5.10129 20.3337 5.44059 20.187L5.44108 20.1868C5.92559 19.9755 6.60733 19.7768 7.21967 19.9367C7.5177 20.0186 7.83474 20.1818 8.21448 20.461L8.21445 20.4611L8.21792 20.4635C8.29491 20.5171 8.36774 20.5747 8.44821 20.6383C8.46141 20.6487 8.47481 20.6593 8.48847 20.6701L8.48906 20.6705L8.49869 20.678C8.73081 20.8592 8.9989 21.0685 9.30541 21.2554C10.538 22.0098 12.0612 22.204 13.4925 21.8107L13.4929 21.8106C14.749 21.4619 15.9023 20.692 16.8259 19.5808L16.8259 19.5807C17.4046 18.8838 17.3082 17.8545 16.6121 17.2735L16.6118 17.2732C15.9149 16.6945 14.8856 16.7909 14.3045 17.4869L14.3043 17.4872C13.8136 18.0778 13.2098 18.4885 12.6174 18.6528C12.0409 18.811 11.4572 18.7343 11.0001 18.4585L11.0002 18.4584L10.9972 18.4567C10.8483 18.371 10.7132 18.2647 10.5692 18.1514C10.5426 18.1305 10.5158 18.1093 10.4884 18.088L10.4884 18.088L10.4865 18.0865C10.4284 18.0426 10.3724 17.9993 10.3156 17.9555L10.3155 17.9554C10.2589 17.9117 10.2016 17.8675 10.142 17.8224L10.1409 17.8216C9.436 17.2981 8.74792 16.948 8.03936 16.7664C6.81211 16.4485 5.45934 16.5934 4.11653 17.1797C3.54755 17.426 3.21351 17.5875 2.84067 17.8586C2.47344 18.1255 2.07026 18.4976 1.35742 19.1562L1.35717 19.1564C0.695761 19.7699 0.653784 20.8083 1.26784 21.4704L2.67349 21.9819Z",
    fill: "url(#paint17_linear_34666_9950)",
    stroke: "url(#paint18_linear_34666_9950)",
    strokeWidth: 0.334113
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34666_9950",
    x1: 50.6512,
    y1: 16.7311,
    x2: -3.24903,
    y2: 65.3916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34666_9950",
    x1: 50.6512,
    y1: 16.7311,
    x2: -3.24903,
    y2: 65.3916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34666_9950",
    x1: 32.9056,
    y1: 16.7311,
    x2: 25.7517,
    y2: 17.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34666_9950",
    x1: 32.9056,
    y1: 16.7311,
    x2: 25.7517,
    y2: 17.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34666_9950",
    x1: 51.2747,
    y1: 16.7311,
    x2: 44.1208,
    y2: 17.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34666_9950",
    x1: 51.2747,
    y1: 16.7311,
    x2: 44.1208,
    y2: 17.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34666_9950",
    x1: 41.365,
    y1: 9.87769,
    x2: 39.7383,
    y2: 14.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34666_9950",
    x1: 41.365,
    y1: 22.834,
    x2: 39.7383,
    y2: 27.9546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34666_9950",
    x1: 41.365,
    y1: 35.7875,
    x2: 39.7383,
    y2: 40.9081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_34666_9950",
    x1: 41.365,
    y1: 48.741,
    x2: 39.7383,
    y2: 53.8616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_34666_9950",
    x1: 44.6784,
    y1: 16.3585,
    x2: 43.0518,
    y2: 21.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_34666_9950",
    x1: 44.6784,
    y1: 29.3149,
    x2: 43.0518,
    y2: 34.4355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_34666_9950",
    x1: 44.6784,
    y1: 42.2595,
    x2: 43.0518,
    y2: 47.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_34666_9950",
    x1: 12.8896,
    y1: 39.5271,
    x2: 10.6143,
    y2: 48.6938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_34666_9950",
    x1: 12.8896,
    y1: 39.5271,
    x2: 10.6143,
    y2: 48.6938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_34666_9950",
    x1: 12.8832,
    y1: 28.6316,
    x2: 10.6068,
    y2: 37.7977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_34666_9950",
    x1: 12.8832,
    y1: 28.6316,
    x2: 10.6068,
    y2: 37.7977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_34666_9950",
    x1: 12.8896,
    y1: 18.0749,
    x2: 10.6145,
    y2: 27.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_34666_9950",
    x1: 12.8896,
    y1: 18.0749,
    x2: 10.6145,
    y2: 27.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsulationOrangeIcon);
export default __webpack_public_path__ + "static/media/insulation_orange_icon.e21d215c5c9b8e311c03b43537305e76.svg";
export { ForwardRef as ReactComponent };